// Set appropriate body margins, based on the header height. Also takes the wp adminbar into account.
export function headerMargin() {
  window.addEventListener('optimizedResize', setHeaderMargin);

  // Wait for initial load then compute margin.
  window.addEventListener('load', setHeaderMargin);
}

export function setHeaderMargin() {
  const header = document.querySelector('.js-page-header');
  const navCollapse = document.querySelector('.collapse');
  const isHome = document.body.classList.contains('home');

  if (!header) {
    return;
  }

  if (window.scrollY === 0) {
    header.classList.add('header--unscrolled');
  } else {
    header.classList.remove('header--unscrolled');
  }

  const wpadminbar = document.querySelector('#wpadminbar');
  const headerBottomMargin = window.getComputedStyle(header).marginBottom;
  const headerHeight = header.offsetHeight;

  if (isHome) {
    const headerSlider = document.querySelector(".ct_headerslider .slick-track");

    if (headerSlider) {
      headerSlider.style.height = `calc(100vh - ${headerHeight}px)`;
    }
  }

  if (header.classList.contains('header--hidden')) {
    document.body.style.marginTop = 0;
    header.style.top = `-${headerHeight}px`;

    if (wpadminbar) {
      header.style.top = `-${wpadminbar.offsetHeight + headerHeight}px`;
    }

    return;
  }

  if (wpadminbar && window.scrollY <= wpadminbar.offsetHeight) {
    header.style.top = `${wpadminbar.offsetHeight}px`;
  } else {
    header.style.top = null;
  }

  if (navCollapse) {
    if (wpadminbar) {
      navCollapse.style.height = `calc(100vh - ${headerHeight}px - ${wpadminbar.offsetHeight}px)`;
    }

    navCollapse.style.height = `calc(100vh - ${headerHeight}px)`;
  }

  document.body.style.marginTop = `calc(${headerHeight}px + ${headerBottomMargin})`;
}

export function headerOnScroll() {
  const header = document.querySelector('.js-page-header');

  if (header) {
    // Initialize scroll position.
    let scrollPos = 0;

    window.addEventListener('optimizedScroll', (e) => {
      // True if the scroll direction is UP or if we are at the top or in a scrollbounce. Also check that we are not in the scrollbounce at the very bottom of a page.
      if (
        window.scrollY === 0 || // We have scrolled all the way up
        (
          (document.body.getBoundingClientRect().top > scrollPos || document.body.getBoundingClientRect().top >= 0) // Scroll direction is up
          && ((window.innerHeight + window.scrollY) < document.body.offsetHeight) // not in bottom scrollbounce
        )
      ) {
        header.classList.remove('header--hidden');
      } else {
        // Only hide the header if no dropdown item or the nav is open, and we have scrolled down at least 100 px
        if (
          !document.querySelector('.navbar-collapse.show') && // Navigation is not opened
          !document.querySelector('.dropdown-menu.show') && // No dropdown in a navigation is opened
          document.body.offsetHeight - window.innerHeight > header.offsetHeight // Page is tall enough to scroll header out of view
        ) {
          header.classList.add('header--hidden');
        }
      }

      // Save the new scrollPos value
      scrollPos = document.body.getBoundingClientRect().top;

      // Compute header margin and position
      setHeaderMargin();
    });
  }
}
